import React, { FC } from 'react';
import useMediaQuery, { sharedMediaQueries } from 'src/common/hooks/useMediaQuery';
import { EXTERNAL_PATHS } from '../../constants';
import NavItemDropdown from './NavItemDropdown';

type ChargeNavItemProps = {
  classNameModifier?: string;
};

const ChargeNavItem: FC<ChargeNavItemProps> = ({ classNameModifier }) => {
  const isMediumAndUpScreenSize = useMediaQuery(sharedMediaQueries.m);

  return (
    <NavItemDropdown
      classNameModifier={classNameModifier}
      icon="credit-card-charge"
      options={[
        {
          dropdownLabel: 'Direct Booking',
          icon: isMediumAndUpScreenSize ? undefined : 'credit-card-arrow',
          id: EXTERNAL_PATHS.CREATE_DIRECT_BOOKING,
        },
        {
          dropdownLabel: 'Add-On Payment',
          icon: isMediumAndUpScreenSize ? undefined : 'credit-card-check',
          id: EXTERNAL_PATHS.CHARGE_ADD_ON,
        },
      ]}
    >
      Charge
    </NavItemDropdown>
  );
};

export default ChargeNavItem;
